import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { FormProvider, useForm } from 'react-hook-form';

import Loader from '../components/Loader/Loader';
import FormOperator from '../components/FormOperator/FormOperator';
import useStyles from '../steps/Step1/styles';
import CardsForms from '../steps/Step4/organisms/CardsForms/CardsForms';
import { billingAddress } from '../constants/selectOptions';
import TipsSection from '../steps/Step4/molecules/TipsSection';
import AdditionalExpenseSummary from './AdditionalExpenseSummary';
import { GET_EXPENSE_PREVIEW_BASE_URL, getFormData } from '../api/api';

export default function FirstStepViewPage() {
  const [apiData, setApiData] = useState( {} );
  const {token} = useParams();
  const classes = useStyles();

  useEffect(() => {
    let mounted = true;
    const url = `${GET_EXPENSE_PREVIEW_BASE_URL}${token}`;
    getFormData(url).then((data) => {
      // console.log(data)
      if (mounted) {
        setApiData(data);
      }
    });
    return () => (mounted = false);
  }, []);

  const methods = useForm( {
    shouldUnregister: false,
    defaultValues: apiData?.result,
    resolver: undefined,
    mode: 'onChange'
  } );

  const {register, setValue, formState} = methods;

  return (
    <FormProvider {...methods}>
      <form style={{paddingBottom: '50px', height: '100%'}}>
        <Grid container style={{height: '100%'}}>
          {typeof apiData === 'object' && Object.keys( apiData ).length > 1 ? (
            <ProductOfferViewForm
              classes={classes}
              apiData={apiData}
              register={register}
              setValue={setValue}
              formState={formState}
            />
          ) : (
            <Grid container>
              <Grid item xs={12} className={classes.mainForm}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  {typeof apiData === 'string' ? (
                    <Typography variant="h2">{apiData}</Typography>
                  ) : (
                    <Loader/>
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
      </form>
    </FormProvider>
  );
}

const ProductOfferViewForm = ( {classes, apiData, register, setValue, formState} ) => {
  const theme = useTheme();
  const show = useMediaQuery( theme.breakpoints.down( 'sm' ) );


  return (
    <>
      <Grid container>
        <Grid item xs={12} md={7} className={classes.mainForm}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            mb={4}
          >
            <Typography variant="h3" align="center">
              {`Dear ${apiData.customer?.first_name} ${apiData.customer?.last_name},`}
            </Typography>
            <Typography variant="body1" align="center">
              Reaching out in regard to the <strong>{apiData.destination}</strong> trip
            </Typography>

          </Box>

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            mb={4}
            px={2}
          >
            <Typography variant="body1" align="center">
              {apiData.remark}
            </Typography>
          </Box>

          <Box
            mb={2.5}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            className={classes.formHeader}
          >

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              className={classes.headerText}
            >
              <Typography variant="h1" align="center">
                Payment information
              </Typography>
              <Typography variant="body1" align="center">
                All transactions are secure and encrypted
              </Typography>
            </Box>
          </Box>
          <Box className={classes.cardForm}>
            <CardsForms
              fields={apiData?.result?.cards}
              currentValues={apiData?.result?.cards}
              defaultCardValues={apiData?.result?.cards}
              addNewCard={() => {
              }}
              billingAddress={billingAddress}
              splitPaymentValue={apiData?.result?.splitPayment}
              remove={() => {
              }}
              setValue={() => {
              }}
              formType="view"
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          className={classes.secondaryForm}
          justifyContent="flex-start"
          alignItems="center"
        >

          <TipsSection
            operatorInfo={apiData?.operatorInfo}
            register={register}
            defaultTips={apiData?.result?.tips}
            setValue={() => {
            }}
            acceptTips={apiData?.result?.acceptTips}
          />

          <AdditionalExpenseSummary
            classes={classes}
            apiData={apiData}
            confirmTerms={apiData?.result?.confirmTerms}
            handleNext={() => {
            }}
            cards={apiData?.result?.cards}
            splitPaymentValue={apiData?.result?.splitPayment}
            register={() => {
            }}
            setValue={() => {
            }}
            cardsAmmount={apiData?.result?.cardsAmmount}
            acceptTipsValue={apiData?.result?.acceptTips}
            tipsValue={apiData?.result?.tips}
            manualSplitValue={apiData?.result?.manualSplit}
            isForceManualSplitValue={false} // TODO
            previewMode={true}
          />

          <Box pb={4} mt={4}>
            <FormOperator operatorInfo={apiData?.operatorInfo}/>
          </Box>

        </Grid>
      </Grid>
    </>
  );
};
